import clsx from 'clsx';

import styles from './index.module.scss';

interface UserBadgeProps {
  text: string;
  color: 'blue' | 'green' | 'black';
  icon?: React.ReactNode;
}

export default function UserBadge({ text, color = 'blue', icon }: UserBadgeProps) {
  return (
    <div className={clsx(styles.userBadge, { [styles[color]]: color, [styles.withIcon]: icon })}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {text}
    </div>
  );
}
